
module.exports = {
  port: process.env.PORT || 1112,
  pipeline_id: process.env.CI_PIPELINE_ID,
  deployment_env: process.env.CI_ENVIRONMENT_NAME || "local",
  carbon_app_api_key: process.env.CARBON_APP_API_KEY,
  stripe_api_key: process.env.STRIPE_CLIENT_ID,
  api_url: process.env.API_URL,
  sentry_dsn: process.env.SENTRY_DSN,
  mycc_base_url: process.env.MYCC_BASE_URL,
  gtm_id: process.env.GTM_ID,
  gtm_preview: process.env.GTM_PREVIEW,
  gtm_auth: process.env.GTM_AUTH
};
